const GRAHAK_GENDER_MAP: { [key: string]: string } = {
  male: 'MALE',
  female: 'FEMALE',
  other: 'OTHERS',
  others: 'OTHERS',
};

export interface ProfileUser {
  id?: string;
  email?: string;
  mobile?: string;
  name?: string;
  firstname?: string;
  lastname?: string;
  dob?: string;
  gender?: string;
  hideEmail?: boolean;
  image_url?: string;
  imageLink?: string;
  [key: string]: any;
}

const GRAHAK_GENDER_REVERSE: { [key: string]: string } = {
  '1': 'male',
  '2': 'female',
  '3': 'other',
  MALE: 'male',
  FEMALE: 'female',
  OTHERS: 'other',
};

export const toLegacyDob = (dob: string): string => {
  if (!dob) return '';

  const date = new Date(dob);
  return isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-GB');
};

export const toGrahakDob = (dob: string): string => {
  if (!dob) return dob;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dob)) return dob;

  const date = new Date(dob);
  if (isNaN(date.getTime())) return dob;

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const splitName = (name = ''): { firstName: string; lastName: string } => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const firstName = parts[0] || '';
  const lastName = parts.length > 1 ? parts[parts.length - 1] : '';
  return { firstName, lastName };
};

export const getGrahakGender = (gender = ''): string | undefined =>
  GRAHAK_GENDER_MAP[gender.toLowerCase()];

export const normalizeGrahakUser = (userDetails: any): ProfileUser => {
  const firstName = userDetails?.firstName || '';
  const lastName = userDetails?.lastName || '';
  const fullName = userDetails?.fullName || `${firstName} ${lastName}`.trim();
  const dobRaw = userDetails?.dob || '';
  const dob = typeof dobRaw === 'string' ? dobRaw.split(' ')[0] : dobRaw;
  const genderRaw =
    userDetails?.gender !== undefined && userDetails?.gender !== null
      ? String(userDetails.gender)
      : '';
  const gender = GRAHAK_GENDER_REVERSE[genderRaw] || genderRaw.toLowerCase();

  return {
    id: userDetails?.userId || '',
    email: userDetails?.email || '',
    mobile: userDetails?.mobile || '',
    name: fullName,
    firstname: firstName,
    lastname: lastName,
    dob,
    gender,
    hideEmail: userDetails?.hideEmail !== undefined ? Boolean(userDetails.hideEmail) : true,
    imageLink: userDetails?.imageLink || '',
    image_url: userDetails?.imageLink || '',
  };
};
